var _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g10, _g11, _g12, _g13, _g14, _g15;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgRoulette(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 496.158 496.158",
    style: {
      enableBackground: "new 0 0 496.158 496.158"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#703D2A"
    },
    d: "M248.082,0.003C111.07,0.003,0,111.063,0,248.085c0,137.001,111.07,248.07,248.082,248.07 c137.006,0,248.076-111.069,248.076-248.07C496.158,111.062,385.088,0.003,248.082,0.003z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#A56C42"
    },
    d: "M248.081,46.5c-111.332,0-201.584,90.244-201.584,201.583c0,111.323,90.252,201.575,201.584,201.575 c111.327,0,201.579-90.251,201.579-201.575C449.661,136.744,359.408,46.5,248.081,46.5z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#C6B8AF"
    },
    d: "M248.081,85.497c-89.793,0-162.585,72.785-162.585,162.585c0,89.787,72.792,162.578,162.585,162.578 c89.79,0,162.582-72.792,162.582-162.578C410.662,158.283,337.871,85.497,248.081,85.497z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#BA7C49"
    },
    d: "M248.081,93.121c-85.583,0-154.961,69.372-154.961,154.961c0,85.576,69.378,154.954,154.961,154.954 c85.579,0,154.958-69.378,154.958-154.954C403.038,162.494,333.66,93.121,248.081,93.121z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#CE2E2E"
    },
    d: "M121.184,159.225c-5.245,7.464-9.749,15.297-13.521,23.375l140.417,65.479L121.184,159.225z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3A3A3A"
    },
    d: "M107.662,182.6c-3.834,8.234-6.908,16.725-9.217,25.384l149.635,40.095L107.662,182.6z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3A3A3A"
    },
    d: "M138.553,138.551c-6.495,6.491-12.27,13.414-17.369,20.674l126.896,88.854L138.553,138.551z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#CE2E2E"
    },
    d: "M98.445,207.984c-2.333,8.736-3.884,17.634-4.658,26.594l154.293,13.501L98.445,207.984z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#CE2E2E"
    },
    d: "M159.226,121.185c-7.264,5.098-14.185,10.882-20.673,17.366L248.08,248.079L159.226,121.185z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#CE2E2E"
    },
    d: "M121.184,336.933l126.884-88.846l-140.397,65.47C111.435,321.643,115.945,329.462,121.184,336.933z  M248.076,248.081l-0.008,0.005l0.012-0.005H248.076z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3A3A3A"
    },
    d: "M93.787,234.578c-0.788,8.98-0.779,18.017-0.004,27l154.297-13.499L93.787,234.578z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3A3A3A"
    },
    d: "M98.448,288.172c2.311,8.658,5.38,17.161,9.224,25.385l140.409-65.476L98.448,288.172z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#CE2E2E"
    },
    d: "M93.783,261.578c0.778,8.957,2.331,17.858,4.665,26.594l149.632-40.091v-0.002L93.783,261.578z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3A3A3A"
    },
    d: "M357.603,138.558L248.08,248.079l126.894-88.854C369.879,151.964,364.095,145.043,357.603,138.558z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3A3A3A"
    },
    d: "M182.599,107.662c-8.083,3.773-15.904,8.277-23.373,13.522l88.854,126.895L182.599,107.662z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3A3A3A"
    },
    d: "M261.578,93.785L248.08,248.079l40.093-149.634C279.44,96.11,270.535,94.561,261.578,93.785z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3A3A3A"
    },
    d: "M313.555,107.667L248.08,248.079l88.854-126.896C329.468,115.943,321.642,111.429,313.555,107.667z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#CE2E2E"
    },
    d: "M336.934,121.183L248.08,248.079l109.523-109.521C351.119,132.069,344.189,126.283,336.934,121.183z "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#CE2E2E"
    },
    d: "M288.173,98.445L248.08,248.079l65.475-140.412C305.33,103.828,296.827,100.763,288.173,98.445z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3A3A3A"
    },
    d: "M121.184,336.933c5.099,7.261,10.883,14.182,17.374,20.668l109.519-109.52L121.184,336.933z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#357157"
    },
    d: "M234.58,93.785l13.5,154.294l13.498-154.294C252.596,93.001,243.561,93.001,234.58,93.785z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3A3A3A"
    },
    d: "M234.58,93.785c-8.952,0.777-17.86,2.325-26.595,4.661l40.095,149.633L234.58,93.785z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#CE2E2E"
    },
    d: "M207.985,98.445c-8.662,2.311-17.153,5.383-25.386,9.217l65.481,140.417L207.985,98.445z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#CE2E2E"
    },
    d: "M248.08,248.079l149.635,40.092c2.333-8.735,3.879-17.639,4.655-26.593L248.08,248.079z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#CE2E2E"
    },
    d: "M248.08,248.079l126.896,88.854c5.241-7.47,9.748-15.29,13.521-23.381L248.08,248.079z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3A3A3A"
    },
    d: "M402.379,234.582L248.08,248.079l154.291,13.499C403.152,252.593,403.154,243.558,402.379,234.582z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#CE2E2E"
    },
    d: "M397.715,207.99L248.08,248.079l154.299-13.497C401.595,225.628,400.048,216.72,397.715,207.99z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#CE2E2E"
    },
    d: "M374.974,159.225L248.08,248.079l140.414-65.476C384.724,174.514,380.217,166.695,374.974,159.225z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3A3A3A"
    },
    d: "M388.494,182.603L248.08,248.079l149.635-40.089C395.404,199.335,392.328,190.831,388.494,182.603z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3A3A3A"
    },
    d: "M248.08,248.079l109.525,109.526c6.49-6.486,12.274-13.41,17.371-20.672L248.08,248.079z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#CE2E2E"
    },
    d: "M248.076,248.081l-109.519,109.52c6.486,6.493,13.412,12.276,20.669,17.38l88.854-126.9H248.076z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#CE2E2E"
    },
    d: "M248.08,248.079v0.002l-13.496,154.294c8.98,0.781,18.017,0.781,26.998-0.004L248.08,248.079z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#CE2E2E"
    },
    d: "M182.603,388.493c8.229,3.841,16.727,6.911,25.382,9.22l40.095-149.631v-0.003L182.603,388.493z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3A3A3A"
    },
    d: "M207.985,397.713c8.737,2.33,17.643,3.889,26.599,4.663l13.496-154.294L207.985,397.713z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3A3A3A"
    },
    d: "M182.603,388.493l65.474-140.407l-88.85,126.895C166.697,380.217,174.516,384.725,182.603,388.493z  M248.077,248.086l0.003-0.005v-0.002L248.077,248.086z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3A3A3A"
    },
    d: "M248.08,248.079l13.502,154.292c8.959-0.772,17.855-2.329,26.591-4.659L248.08,248.079z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3A3A3A"
    },
    d: "M248.08,248.079l65.475,140.414c8.087-3.769,15.908-8.276,23.377-13.516L248.08,248.079z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#CE2E2E"
    },
    d: "M248.08,248.079l88.852,126.898c7.263-5.097,14.187-10.883,20.673-17.372L248.08,248.079z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#CE2E2E"
    },
    d: "M248.08,248.079l40.093,149.634c8.662-2.313,17.153-5.378,25.382-9.22L248.08,248.079z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3A3A3A"
    },
    d: "M248.08,248.079l140.418,65.473c3.83-8.226,6.906-16.721,9.217-25.381L248.08,248.079z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#BFAFA5"
    },
    d: "M248.08,117.105c-72.336,0-130.977,58.635-130.977,130.976c0,72.331,58.64,130.971,130.977,130.971 c72.333,0,130.974-58.64,130.974-130.971C379.054,175.741,320.414,117.105,248.08,117.105z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#C6854A"
    },
    d: "M248.08,123.984c-68.538,0-124.098,55.556-124.098,124.098c0,68.533,55.561,124.093,124.098,124.093 c68.535,0,124.095-55.561,124.095-124.093C372.176,179.539,316.615,123.984,248.08,123.984z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E03636"
    },
    d: "M144.124,175.288c-4.297,6.114-7.987,12.531-11.077,19.149l115.033,53.642L144.124,175.288z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3A3A3A"
    },
    d: "M133.047,194.438c-3.141,6.745-5.659,13.701-7.551,20.795l122.584,32.846L133.047,194.438z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3A3A3A"
    },
    d: "M158.353,158.351c-5.32,5.317-10.052,10.989-14.229,16.937l103.956,72.791L158.353,158.351z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E03636"
    },
    d: "M125.496,215.233c-1.911,7.157-3.182,14.446-3.815,21.786l126.399,11.06L125.496,215.233z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E03636"
    },
    d: "M175.289,144.125c-5.951,4.176-11.621,8.915-16.936,14.226l89.727,89.728L175.289,144.125z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E03636"
    },
    d: "M144.124,320.87l103.945-72.784L133.054,301.72C136.138,308.344,139.833,314.749,144.124,320.87z  M248.077,248.081l-0.007,0.005l0.01-0.005H248.077z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3A3A3A"
    },
    d: "M121.681,237.019c-0.646,7.356-0.639,14.76-0.004,22.119l126.403-11.059L121.681,237.019z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3A3A3A"
    },
    d: "M125.498,280.924c1.893,7.093,4.408,14.058,7.556,20.796l115.025-53.639L125.498,280.924z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E03636"
    },
    d: "M121.677,259.138c0.638,7.337,1.91,14.629,3.821,21.787l122.582-32.843v-0.003L121.677,259.138z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3A3A3A"
    },
    d: "M337.803,158.357l-89.723,89.722l103.954-72.791C347.86,169.34,343.121,163.67,337.803,158.357z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3A3A3A"
    },
    d: "M194.436,133.047c-6.621,3.091-13.029,6.781-19.147,11.078l72.791,103.954L194.436,133.047z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3A3A3A"
    },
    d: "M259.138,121.678L248.08,248.079l32.845-122.583C273.77,123.583,266.475,122.315,259.138,121.678z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3A3A3A"
    },
    d: "M301.718,133.051L248.08,248.079l72.791-103.956C314.754,139.831,308.343,136.133,301.718,133.051z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E03636"
    },
    d: "M320.871,144.123L248.08,248.079l89.723-89.722C332.491,153.041,326.814,148.302,320.871,144.123z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E03636"
    },
    d: "M280.925,125.496L248.08,248.079l53.638-115.028C294.98,129.906,288.014,127.395,280.925,125.496z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3A3A3A"
    },
    d: "M144.124,320.87c4.177,5.948,8.916,11.618,14.233,16.932l89.719-89.72L144.124,320.87z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#398764"
    },
    d: "M237.02,121.678l11.06,126.401l11.058-126.401C251.779,121.037,244.377,121.037,237.02,121.678z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3A3A3A"
    },
    d: "M237.02,121.678c-7.334,0.637-14.631,1.905-21.787,3.818l32.847,122.583L237.02,121.678z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E03636"
    },
    d: "M215.234,125.496c-7.096,1.894-14.053,4.41-20.797,7.551l53.643,115.032L215.234,125.496z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E03636"
    },
    d: "M248.08,248.079l122.583,32.844c1.911-7.156,3.178-14.45,3.813-21.785L248.08,248.079z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E03636"
    },
    d: "M248.08,248.079l103.956,72.791c4.293-6.12,7.985-12.525,11.077-19.154L248.08,248.079z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3A3A3A"
    },
    d: "M374.484,237.022L248.08,248.079l126.397,11.059C375.118,251.777,375.119,244.375,374.484,237.022z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E03636"
    },
    d: "M370.663,215.237L248.08,248.079l126.404-11.057C373.842,229.687,372.575,222.39,370.663,215.237z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E03636"
    },
    d: "M352.034,175.288L248.08,248.079l115.029-53.639C360.021,187.814,356.329,181.408,352.034,175.288z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3A3A3A"
    },
    d: "M363.109,194.44L248.08,248.079l122.583-32.842C368.77,208.147,366.25,201.181,363.109,194.44z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3A3A3A"
    },
    d: "M248.08,248.079l89.725,89.725c5.316-5.313,10.055-10.985,14.23-16.935L248.08,248.079z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E03636"
    },
    d: "M248.077,248.081l-89.719,89.72c5.313,5.319,10.987,10.057,16.932,14.238l72.791-103.958H248.077z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E03636"
    },
    d: "M248.08,248.079v0.002l-11.056,126.4c7.357,0.64,14.76,0.64,22.117-0.003L248.08,248.079z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E03636"
    },
    d: "M194.44,363.109c6.741,3.146,13.703,5.661,20.794,7.553l32.846-122.581v-0.002L194.44,363.109z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3A3A3A"
    },
    d: "M215.234,370.662c7.158,1.909,14.453,3.186,21.79,3.819l11.056-126.4L215.234,370.662z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3A3A3A"
    },
    d: "M248.077,248.085l0.003-0.004v-0.002L248.077,248.085z M194.44,363.109l53.637-115.024 l-72.788,103.954C181.41,356.329,187.815,360.021,194.44,363.109z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3A3A3A"
    },
    d: "M248.08,248.079l11.061,126.399c7.339-0.633,14.627-1.908,21.784-3.816L248.08,248.079z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3A3A3A"
    },
    d: "M248.08,248.079l53.638,115.03c6.625-3.087,13.032-6.78,19.151-11.073L248.08,248.079z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E03636"
    },
    d: "M248.08,248.079l72.789,103.957c5.95-4.175,11.622-8.916,16.936-14.232L248.08,248.079z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E03636"
    },
    d: "M248.08,248.079l32.845,122.583c7.096-1.895,14.052-4.406,20.793-7.553L248.08,248.079z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3A3A3A"
    },
    d: "M248.08,248.079l115.033,53.636c3.137-6.738,5.657-13.698,7.551-20.792L248.08,248.079z"
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#E2E2E2"
    },
    cx: 248.079,
    cy: 135.049,
    r: 9
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M247.803,126.995c-4.45,0-8.058,3.607-8.058,8.058s3.607,8.057,8.058,8.057 C252.253,143.11,252.253,126.995,247.803,126.995z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#CEC0B7"
    },
    d: "M248.08,149.619c-54.379,0-98.462,44.08-98.462,98.462c0,54.375,44.083,98.459,98.462,98.459 c54.377,0,98.46-44.083,98.46-98.459C346.54,193.698,302.457,149.619,248.08,149.619z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#D89450"
    },
    d: "M248.08,153.744c-52.101,0-94.337,42.233-94.337,94.337c0,52.097,42.236,94.333,94.337,94.333 c52.099,0,94.335-42.236,94.335-94.333C342.415,195.977,300.179,153.744,248.08,153.744z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E09F65"
    },
    d: "M308.69,184.708c-34.237-34.238-89.745-34.24-123.984,0c-34.235,34.235-34.235,89.745,0.002,123.982 c17.081,17.08,56.5-5.22,87.464-36.11C303.273,241.555,325.846,201.864,308.69,184.708z"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "SVGCleanerId_0",
    x: 246.579,
    y: 153.389,
    style: {
      fill: "#685B51"
    },
    width: 3,
    height: 189.39
  }), /*#__PURE__*/React.createElement("rect", {
    id: "SVGCleanerId_1",
    x: 153.389,
    y: 246.579,
    style: {
      fill: "#685B51"
    },
    width: 189.39,
    height: 3
  }), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.7071 -0.7071 0.7071 0.7071 -106.04 256)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGCleanerId_1_1_",
    x: 161.31,
    y: 243.298,
    style: {
      fill: "#685B51"
    },
    width: 189.39,
    height: 3
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGCleanerId_0_1_",
    x: 254.5,
    y: 150.108,
    style: {
      fill: "#685B51"
    },
    width: 3,
    height: 189.39
  }))), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#685B51"
    },
    cx: 248.079,
    cy: 248.079,
    r: 30.336
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#4C4642"
    },
    cx: 248.079,
    cy: 248.079,
    r: 13.211
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#C1BDBC"
    },
    d: "M248,49.053c-1.75,0-5.5,7.387-5.5,16.5s3.25,16.5,5.5,16.5c2.25,0,5.5-7.387,5.5-16.5 S249.75,49.053,248,49.053z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#D8D8D8"
    },
    d: "M248,49.053c-1.75,0-5.5,7.387-5.5,16.5s3.25,16.5,5.5,16.5C250.25,82.053,249.75,49.053,248,49.053z "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#C1BDBC"
    },
    d: "M248,414.053c-1.75,0-5.5,7.387-5.5,16.5s3.25,16.5,5.5,16.5c2.25,0,5.5-7.387,5.5-16.5 S249.75,414.053,248,414.053z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#D8D8D8"
    },
    d: "M248,414.053c-1.75,0-5.5,7.387-5.5,16.5s3.25,16.5,5.5,16.5 C250.25,447.053,249.75,414.053,248,414.053z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#C1BDBC"
    },
    d: "M430.5,242.553c-9.113,0-16.5,3.25-16.5,5.5s7.387,5.5,16.5,5.5s16.5-3.75,16.5-5.5 S439.613,242.553,430.5,242.553z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#D8D8D8"
    },
    d: "M430.5,242.553c-9.113,0-16.5,3.25-16.5,5.5s33,1.75,33,0S439.613,242.553,430.5,242.553z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#C1BDBC"
    },
    d: "M65.5,242.553c-9.113,0-16.5,3.25-16.5,5.5s7.387,5.5,16.5,5.5s16.5-3.75,16.5-5.5 S74.613,242.553,65.5,242.553z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#D8D8D8"
    },
    d: "M65.5,242.553c-9.113,0-16.5,3.25-16.5,5.5s33,1.75,33,0S74.613,242.553,65.5,242.553z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#C1BDBC"
    },
    d: "M388.715,107.339c-1.238-1.237-9.113,1.334-15.557,7.778c-6.444,6.444-9.369,13.965-7.778,15.556 c1.591,1.591,9.112-1.334,15.556-7.778C387.38,116.452,389.952,108.576,388.715,107.339z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#D8D8D8"
    },
    d: "M388.715,107.339c-1.238-1.237-9.113,1.334-15.557,7.778c-6.444,6.444-9.369,13.965-7.778,15.556 C366.971,132.264,389.952,108.576,388.715,107.339z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#C1BDBC"
    },
    d: "M130.621,365.433c-1.237-1.238-9.112,1.334-15.556,7.778s-9.369,13.965-7.778,15.557 c1.591,1.591,9.113-1.334,15.556-7.778C129.286,374.545,131.858,366.67,130.621,365.433z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#D8D8D8"
    },
    d: "M130.621,365.433c-1.237-1.238-9.112,1.334-15.556,7.778s-9.369,13.965-7.778,15.557 C108.877,390.358,131.858,366.67,130.621,365.433z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#C1BDBC"
    },
    d: "M380.936,373.211c-6.444-6.444-13.965-9.369-15.556-7.778s1.334,9.112,7.778,15.556 s14.319,9.016,15.557,7.778C389.952,387.53,387.38,379.655,380.936,373.211z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#D8D8D8"
    },
    d: "M380.936,373.211c-6.444-6.444-13.965-9.369-15.556-7.778s22.097,24.572,23.334,23.334 C389.952,387.53,387.38,379.655,380.936,373.211z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#C1BDBC"
    },
    d: "M122.842,115.117c-6.443-6.444-13.965-9.369-15.556-7.778s1.334,9.113,7.778,15.556 c6.444,6.444,14.319,9.016,15.556,7.778S129.286,121.561,122.842,115.117z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#D8D8D8"
    },
    d: "M122.842,115.117c-6.443-6.444-13.965-9.369-15.556-7.778s22.097,24.572,23.334,23.334 S129.286,121.561,122.842,115.117z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#C1BDBC"
    },
    d: "M320.24,74.578c-8.405-3.521-16.474-3.379-17.344-1.304c-0.869,2.075,4.688,7.928,13.092,11.449 c8.405,3.522,16.667,2.918,17.344,1.305C334.009,84.413,328.645,78.1,320.24,74.578z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#D8D8D8"
    },
    d: "M320.24,74.578c-8.405-3.521-16.474-3.379-17.344-1.304c-0.869,2.075,29.76,14.368,30.436,12.754 C334.009,84.413,328.645,78.1,320.24,74.578z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#C1BDBC"
    },
    d: "M180.015,409.219c-8.405-3.522-16.474-3.379-17.343-1.304c-0.87,2.075,4.688,7.927,13.092,11.45 c8.405,3.521,16.667,2.918,17.343,1.304C193.784,419.055,188.42,412.741,180.015,409.219z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#D8D8D8"
    },
    d: "M180.015,409.219c-8.405-3.522-16.474-3.379-17.343-1.304c-0.87,2.075,29.759,14.368,30.436,12.753 C193.784,419.055,188.42,412.741,180.015,409.219z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#C1BDBC"
    },
    d: "M421.7,301.866c-2.075-0.869-7.927,4.688-11.449,13.092s-2.918,16.667-1.304,17.344 c1.614,0.676,7.928-4.688,11.45-13.092C423.917,310.805,423.775,302.735,421.7,301.866z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#D8D8D8"
    },
    d: "M421.7,301.866c-2.075-0.869-14.367,29.76-12.753,30.436s7.928-4.688,11.45-13.092 C423.917,310.805,423.775,302.735,421.7,301.866z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#C1BDBC"
    },
    d: "M87.059,161.641c-2.075-0.87-7.928,4.688-11.45,13.092c-3.521,8.405-2.917,16.667-1.304,17.343 c1.614,0.677,7.927-4.688,11.449-13.092C89.276,170.579,89.134,162.51,87.059,161.641z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#D8D8D8"
    },
    d: "M87.059,161.641c-2.075-0.87-14.368,29.759-12.754,30.436c1.614,0.677,7.927-4.688,11.449-13.092 C89.276,170.579,89.134,162.51,87.059,161.641z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#C1BDBC"
    },
    d: "M420.944,176.057c-3.453-8.433-9.26-14.038-11.342-13.186c-2.082,0.853-2.291,8.92,1.162,17.354 c3.453,8.434,9.722,13.85,11.341,13.187C423.725,192.747,424.397,184.491,420.944,176.057z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#D8D8D8"
    },
    d: "M420.944,176.057c-3.453-8.433-9.26-14.038-11.342-13.186c-2.082,0.853,10.884,31.203,12.503,30.54 C423.725,192.747,424.397,184.491,420.944,176.057z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#C1BDBC"
    },
    d: "M85.162,313.53c-3.453-8.434-9.259-14.039-11.341-13.186c-2.083,0.853-2.291,8.92,1.162,17.354 c3.453,8.433,9.722,13.849,11.342,13.186C87.944,330.221,88.616,321.964,85.162,313.53z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#D8D8D8"
    },
    d: "M85.162,313.53c-3.453-8.434-9.259-14.039-11.341-13.186c-2.083,0.853,10.884,31.203,12.503,30.54 C87.944,330.221,88.616,321.964,85.162,313.53z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#C1BDBC"
    },
    d: "M331.97,408.517c-0.853-2.082-8.92-2.291-17.354,1.162c-8.434,3.453-13.849,9.723-13.186,11.342 c0.663,1.62,8.92,2.291,17.354-1.161C327.217,416.406,332.823,410.599,331.97,408.517z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#D8D8D8"
    },
    d: "M331.97,408.517c-0.853-2.082-31.203,10.884-30.54,12.503c0.663,1.62,8.92,2.291,17.354-1.161 C327.217,416.406,332.823,410.599,331.97,408.517z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#C1BDBC"
    },
    d: "M194.497,72.736c-0.852-2.083-8.92-2.292-17.354,1.161c-8.433,3.453-13.849,9.722-13.186,11.341 c0.663,1.62,8.92,2.291,17.353-1.161C189.745,80.624,195.35,74.818,194.497,72.736z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#D8D8D8"
    },
    d: "M194.497,72.736c-0.852-2.083-31.203,10.883-30.54,12.502c0.663,1.62,8.92,2.291,17.353-1.161 C189.745,80.624,195.35,74.818,194.497,72.736z"
  }), _g || (_g = /*#__PURE__*/React.createElement("g", null)), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null)), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null)), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null)), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", null)), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", null)), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", null)), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", null)), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", null)), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", null)), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", null)), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", null)), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", null)), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", null)), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", null)));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRoulette);
export default __webpack_public_path__ + "static/media/roulette.31c296b0cb4d40f158b8cb0738a372c9.svg";
export { ForwardRef as ReactComponent };